import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-driver-load-actions-dropdown',
  templateUrl: './driver-load-actions-dropdown.component.html',
  styleUrls: ['./driver-load-actions-dropdown.component.css']
})
export class DriverLoadActionsDropdownComponent implements OnInit {
  isClose = false;
  @Input() assign;
  @Input() preferedTrip;

  @Output() assignTripAction = new EventEmitter<any>();
  @Output() editTripAction = new EventEmitter<any>();
  @Output() driverBreakAction = new EventEmitter<any>();
  @Output() cancelBreakAction = new EventEmitter<any>();
  @Output() setPartialEditModalAction = new EventEmitter<any>();
  @Output() dropTripAction = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  isStringExist(substrings, str) {
    if (substrings.some(v => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

}
